import {Button, Overlay, OverlayTrigger, Popover, Tooltip} from "react-bootstrap";
import React, {useRef, useState} from "react";

export function ABOverlayTooltip({tip, placement = "top", children}) {
    const renderTooltip = (props) => (
        <Tooltip id={`tooltip-${tip}`} {...props} className="custom-tooltip">
            {tip}
        </Tooltip>
    );

    return (
        <OverlayTrigger
            placement={placement}
            delay={{ show: 700, hide: 100 }}
            overlay={renderTooltip}
        >
            <span>{children}</span>
        </OverlayTrigger>
    );
}

export function ABOverlayTooltipClick({tip, placement = "top", children}) {
    const [show, setShow] = useState(false);
    const target = useRef(null);

    return (
        <>
            <div ref={target} onClick={() => setShow(!show)}>
                {children}
            </div>
            <Overlay target={target.current} show={show} placement={placement}>
                {({
                      placement: _placement,
                      arrowProps: _arrowProps,
                      show: _show,
                      popper: _popper,
                      hasDoneInitialMeasure: _hasDoneInitialMeasure,
                      ...props}) => (
                    <div
                        {...props}
                        style={{
                            position: 'absolute',
                            backgroundColor: 'rgba(00, 71, 171, 0.85)',
                            padding: '2px 10px',
                            color: 'white',
                            borderRadius: 4,
                            ...props.style,
                        }}
                    >
                        {tip}
                    </div>
                )}
            </Overlay>
        </>
    );
}

export function ABOverlayPopover({headerText, buttonLabel, children, placement = 'right', trigger = 'focus'}) {
    const popover = (
        <Popover id="ab-popover">
            {headerText && <Popover.Header as="h3">{headerText}</Popover.Header>}
            <Popover.Body>{children}</Popover.Body>
        </Popover>
    );

    return (
        <OverlayTrigger trigger={trigger} placement={placement} overlay={popover}>
            <Button variant="link" className="p-0 text-decoration-none">
                <div className="fw-semibold text-body-secondary text-capitalize">{buttonLabel}</div>
            </Button>
        </OverlayTrigger>

    )
}